export const USER_BINDER_QUERY_KEYS = {
  all: ['userBinder'] as const,
  detail: (currentUserId?: string, ownerUserId?: string, artistId?: string, memberId?: string) =>
    [
      ...USER_BINDER_QUERY_KEYS.all,
      'detail',
      currentUserId,
      ownerUserId,
      artistId,
      memberId
    ] as const,
  covers: (currentUserId?: string, ownerUserId?: string, artistId?: string) =>
    [...USER_BINDER_QUERY_KEYS.all, 'covers', currentUserId, ownerUserId, artistId] as const
};
